module.exports = __webpack_public_path__ + "static/media/HowItWorksSmall.b6068252.mp4";